const getDefaultAdminsState = () => {
  return {
    allAdmins: [],
    allUsers: [],
  }
}

export default getDefaultAdminsState()
export { getDefaultAdminsState }
